<template>
  <footer class="pagefooter-container">
    <div class="pagefooter-dim"></div>
    <!-- 비로그인 NOLOGIN-->
    <div class="pagefooter-wrap" v-if="isShowNoLogin">
      <ul class="h_100per pagefooter">
        <li class="pagefooter-leftwrap">
          <div class="noalbumimg"></div>
          <div class="musicinfo-wrap">
            <div class="musicinfo-musicname-wrap">
              <div class="musicinfo-musicname" v-html="`현재 재생중인 채널 정보가 없습니다.`"></div>
            </div>
          </div>
        </li>
        <li class="pagefooter-middlewrap " :class="getMyChannelType ? '' : 'nomusic'">
          <img @click="nologinfunc" class="prev-icon" src="/media/images/icon/prev-icon.png" alt="prev-icon" />
          <div class="playcontrol-wrap">
            <img
              v-if="getIsPlay"
              @click="nologinfunc"
              class="pause-icon"
              src="/media/images/icon/pause-icon.png"
              alt="play-icon.png"
            />
            <img
              v-else
              @click="nologinfunc"
              class="play-icon"
              src="/media/images/icon/play-icon.png"
              alt="play-icon.png"
            />
          </div>
          <img @click="nologinfunc" class="next-icon" src="/media/images/icon/next-icon.png" alt="prev-icon" />
        </li>
        <li class="pagefooter-rightwrap">
          <div class="volume-manage" v-show="getMyChannelType">
            <img class="volume-icon" src="/media/images/icon/volume-icon.png" alt="volume-icon" />
            <div class="volume-wrap">
              <input ref="volumeRange" type="range" min="0" max="1" step="0.1" />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 구독 SUBSCRIBED && TRIAL_WITH_SPACE – 스페이스 존재 + 체험용 && TRIAL_NO_SPACE – 스페이스 없음 + 체험용 -->
    <div class="pagefooter-wrap" v-if="isShowPlayer">
      <ul class="h_100per pagefooter">
        <!-- 채널 타입 존재하는 경우 -->
        <li v-if="getMyChannelType" class="pagefooter-leftwrap cursor" @click="clickMiniPlayer">
          <img class="albumimg" :src="getChannelImg" alt="dummy-album.jpeg" />
          <div class="musicinfo-wrap">
            <div class="musicinfo-musicname-wrap" v-rollingv2="{ speed: 0.5 }">
              <div class="musicinfo-musicname" v-html="getChannelName"></div>
            </div>
            <div v-if="getMusicInfo" v-rollingv2="{ speed: 0.5 }" class="musicinfo-artist-wrap">
              <div class="musicinfo-artist" v-html="getMusicInfo"></div>
            </div>
          </div>
        </li>
        <!-- 채널 타입 존재하지 않는 경우 -->
        <li v-else class="pagefooter-leftwrap">
          <div class="noalbumimg"></div>
          <div class="musicinfo-wrap">
            <div class="musicinfo-musicname-wrap">
              <div class="musicinfo-musicname" v-html="`현재 재생중인 채널 정보가 없습니다.`"></div>
            </div>
          </div>
        </li>
        <li class="pagefooter-middlewrap " :class="getMyChannelType ? '' : 'nomusic'">
          <img
            class="prev-icon"
            @click="getMyChannelType ? onClickPrevNext(`prev`) : () => {}"
            src="/media/images/icon/prev-icon.png"
            alt="prev-icon"
          />
          <div class="playcontrol-wrap" @click="getMyChannelType ? onClickControlMusic() : () => {}">
            <img v-if="getIsPlay" class="pause-icon" src="/media/images/icon/pause-icon.png" alt="play-icon.png" />
            <img v-else class="play-icon" src="/media/images/icon/play-icon.png" alt="play-icon.png" />
          </div>
          <img
            class="next-icon"
            @click="getMyChannelType ? onClickPrevNext(`next`) : () => {}"
            src="/media/images/icon/next-icon.png"
            alt="prev-icon"
          />
        </li>
        <li class="pagefooter-rightwrap">
          <div class="icon-group" v-if="getMyChannelType">
            <a tabindex="0" class="icon-wrap" @click="onClickLikeUnLike('like')">
              <img v-if="isLike" class="like-icon" src="/media/images/icon/like-active-icon.png" alt="like-icon.png" />
              <img v-else class="like-icon" src="/media/images/icon/like-icon.png" alt="like-icon.png" />
            </a>
            <a tabindex="0" class="icon-wrap" @click="onClickLikeUnLike('unlike')">
              <img
                v-if="isUnLike"
                class="dislike-icon"
                src="/media/images/icon/dislike-active-icon.png"
                alt="like-icon.png"
              />
              <img v-else class="dislike-icon" src="/media/images/icon/dislike-icon.png" alt="like-icon.png" />
            </a>
            <a tabindex="0" class="icon-wrap" @click="onClickReportModal">
              <img class="write-icon" src="/media/images/icon/write-icon.png" alt="like-icon.png" />
            </a>
            <a tabindex="0" class="icon-wrap" @click="onClickReport">
              <img class="report-icon" src="/media/images/icon/report-icon.png" alt="like-icon.png" />
            </a>
          </div>
          <div class="volume-manage" v-show="getMyChannelType">
            <img
              v-if="!isMute"
              class="volume-icon"
              @click="onClickMute"
              src="/media/images/icon/volume-icon.png"
              alt="volume-icon"
            />
            <img
              v-else-if="isMute"
              class="volume-icon"
              @click="onClickMute"
              src="/media/images/icon/mute-icon.png"
              alt="volume-icon"
            />
            <div class="volume-wrap">
              <input ref="volumeRange" type="range" min="0" max="1" step="0.1" @change="onChangeVolume" />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!--  && UNSUBSCRIBED_NO_SPACE  + 미구독 + 스페이스 없음 -->
    <div class="pagefooter-wrap" v-if="isShowUnsubscribeNoSpace">
      <div class="undescribe-wrap">
        <p class="undescribe-text">스페이스를 만들고, 서비스를 계속 이용해보세요.</p>
        <div class="newspace-btn">
          <BasicButton :boxsize="'sm'" @click-btn="onClickNewSpace">
            <template #btnname>
              스페이스 만들기
            </template>
          </BasicButton>
        </div>
      </div>
    </div>
    <!-- UNSUBSCRIBED_WITH_SPACE 미구독 + 스페이스 존재 -->
    <div class="pagefooter-wrap" v-if="isShowUnsubscribeSpace">
      <div class="undescribe-wrap">
        <p class="undescribe-text">해당 스페이스의 구독이 만료되었습니다. 재구독하시겠습니까?</p>
        <div class="undescirbe-btn">
          <BasicButton :boxsize="'sm'" @click-btn="onClickUnSubscribe">
            <template #btnname>
              구독하기
            </template>
          </BasicButton>
        </div>
      </div>
    </div>
    <!-- AI음악 재생중 -->
    <div class="pagefooter-wrap" v-if="isplayaimusicsong">
      <ul class="h_100per pagefooter">
        <!-- 채널 타입 존재하는 경우 -->
        <li class="pagefooter-leftwrap cursor">
          <img class="albumimg" src="/media/img/aimusic/welcomeaimusic-img.jpg" alt="dummy-album.jpeg" />
          <div class="musicinfo-wrap">
            <div class="musicinfo-musicname-wrap" v-rollingv2="{ speed: 0.5 }">
              <div class="musicinfo-musicname" v-html="getAiMusicChannelName"></div>
            </div>
            <div v-if="getMusicInfo" v-rollingv2="{ speed: 0.5 }" class="musicinfo-artist-wrap">
              <div class="musicinfo-artist" v-html="getAiMusicMusicName"></div>
            </div>
          </div>
        </li>
        <li class="pagefooter-middlewrap-aichannelmusic">
          <p class="aichannelmusic-title1">지금 {{ getSpaceCardInfo.spaceNm }}만의 특별한 로고송이 나오고 있어요.</p>
          <p class="aichannelmusic-title2">
            로고송이 끝나면 매장 전용 플레이리스트가 재생되며, 안내/방송 메뉴에서 다시 듣고 주기적으로 재생할 수 있어요.
          </p>
        </li>
        <li class="pagefooter-rightwrap">
          <div class="volume-manage">
            <img
              v-if="!isMute"
              class="volume-icon"
              @click="onClickMute"
              src="/media/images/icon/volume-icon.png"
              alt="volume-icon"
            />
            <img
              v-else-if="isMute"
              class="volume-icon"
              @click="onClickMute"
              src="/media/images/icon/mute-icon.png"
              alt="volume-icon"
            />
            <div class="volume-wrap">
              <input ref="volumeRange" type="range" min="0" max="1" step="0.1" @change="onChangeVolume" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </footer>
</template>
<script>
import rolling from '@/utils/directive/rolling';
import BasicButton from '../BasicButton/BasicButton.vue';
export default {
  props: {
    nologinfunc: {
      type: Function,
      default: () => {},
      required: false
    },
    isplayaimusicsong: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  directives: {
    rolling
  },
  components: {
    BasicButton
  },
  emits: ['click-miniplayer', 'click-report', 'click-reportmodal', 'click-newspace', 'click-unsubscribespace'],
  created() {},
  methods: {
    setAiMusicMuted(val) {
      const aiMusiceVideo = document.querySelector('video#aimusic_video');
      if (aiMusiceVideo) {
        aiMusiceVideo.muted = val;
      }
    },
    setAiMusicVolume(val) {
      const aiMusiceVideo = document.querySelector('video#aimusic_video');
      if (aiMusiceVideo) {
        aiMusiceVideo.volume = val;
      }
    },
    setBackGround(ele, value = 0.1) {
      const standard = value;
      ele.value = value;
      const gradientValue = 100 / ele.attributes.max.value;
      ele.style.background = `linear-gradient(to right, #404040 0%, #404040 ${
        // eslint-disable-next-line camelcase
        gradientValue * standard
        // eslint-disable-next-line camelcase
      }%, hsla(0, 0%, 92%, 1)  ${gradientValue * standard}%, hsla(0, 0%, 92%, 1) 100%)`;
    },
    onChangeVolume($event) {
      this.$VideoPlayer.setVolume($event.target.value);
      this.$BrandPlayer.setBrandVideoVolume($event.target.value);
      this.setAiMusicVolume($event.target.value);
      this.setBackGround(this.$refs.volumeRange, $event.target.value);
      if (Number($event.target.value) !== 0) {
        if (!this.$store.getters.gettersIsBrandMusic) this.$VideoPlayer.setMuted(false);
        this.$BrandPlayer.onBrandMute(false);
        if (this.$store.getters.gettersIsPlay) this.setAiMusicMuted(false);
        this.$store.commit('player/setVolume', Number($event.target.value));
      }
    },
    async onClickPrevNext(dir = 'prev') {
      if (dir === 'prev') {
        this.$gatag.event('web_main_player_prev_button'); // 이전채널
      } else {
        this.$gatag.event('web_main_player_next_button'); // 다음채널
      }

      await this.$store.dispatch('player/prevNextChanel', {
        direction: dir
      });
    },
    onClickNewSpace() {
      this.$emit('click-newspace');
    },
    onClickUnSubscribe() {
      this.$emit('click-unsubscribespace');
    },
    clickMiniPlayer() {
      this.$emit('click-miniplayer');
    },
    onClickControlMusic() {
      this.$gatag.event('web_player_page_play_button'); // 재생버튼
      this.$store.dispatch('controlMusic');
    },
    onClickLikeUnLike(type = 'like') {
      if (type === 'like') {
        this.$gatag.event('web_player_page_like_button'); // 좋아요 버튼
      } else if (type === 'unlike') {
        this.$gatag.event('web_player_page_dislike_button'); // 싫어요
      }
      this.$store.dispatch('player/saveMuiscLikeUnLike', type);
    },
    onClickReport() {
      this.$gatag.event('web_player_page_report_button'); // 신고하기
      this.$emit('click-report');
    },
    onClickReportModal() {
      this.$gatag.event('web_player_page_comment_button'); // 한줄평
      this.$emit('click-reportmodal');
    },
    onClickMute() {
      // AI뮤직이이고 state.isPlay가 false이면 muted은 해지 못하도록 처리
      if (this.isMute) {
        if (!this.$store.getters.gettersIsBrandMusic) this.$VideoPlayer.setMuted(false);
        this.$BrandPlayer.onBrandMute(false);
        if (this.$store.getters.gettersIsPlay) this.setAiMusicMuted(false);
        this.$store.commit('setMute', false);
      } else {
        this.$VideoPlayer.setVolume(0);
        this.$BrandPlayer.setBrandVideoVolume(0);
        this.setAiMusicVolume(0);
        this.$VideoPlayer.setMuted(true);
        this.$BrandPlayer.onBrandMute(true);
        this.setAiMusicMuted(true);
        this.$store.commit('setMute', true);
      }
    }
  },
  async mounted() {
    await this.$nextTick();

    this.$VideoPlayer.setVolume(this.$store.getters['player/getVolume']);
    this.$BrandPlayer.setBrandVideoVolume(this.$store.getters['player/getVolume']);

    if (this.$refs.volumeRange) {
      this.setBackGround(
        this.$refs.volumeRange,
        this.$store.getters['player/getVolume'] ? this.$store.getters['player/getVolume'] : 1
      );
    }
  },

  computed: {
    getChannelImg() {
      return this.$store.getters['player/getChannelImage'];
    },
    getChannelName() {
      return this.$store.getters['player/getChannelName'];
    },
    getMyChannelType() {
      return this.$store.getters['player/getMyChannelInfo'].channelType;
    },
    getMusicInfo() {
      return this.$store.getters.gettersChannelMusicInfo;
    },
    getIsPlay() {
      return this.$store.getters.gettersIsPlay;
    },
    isLike() {
      const { like } = this.$store.getters.getLikeInfo;
      if (like === 'Y') {
        return true;
      }

      return false;
    },
    isUnLike() {
      const { unlike } = this.$store.getters.getLikeInfo;
      if (unlike === 'Y') {
        return true;
      }
      return false;
    },
    isMute() {
      return this.$store.state.isMute;
    },
    isShowNoLogin() {
      const authName = this.$store.getters['auth/getAuthName'];
      if (authName === 'NOLOGIN') {
        return true;
      }
      return false;
    },
    isShowPlayer() {
      const authName = this.$store.getters['auth/getAuthName'];
      if (!this.isplayaimusicsong) {
        if (authName === 'SUBSCRIBED' || authName === 'TRIAL_WITH_SPACE' || authName === 'TRIAL_NO_SPACE') {
          return true;
        }
      }

      return false;
    },
    isShowUnsubscribeNoSpace() {
      const authName = this.$store.getters['auth/getAuthName'];
      if (!this.isplayaimusicsong) {
        if (authName === 'UNSUBSCRIBED_NO_SPACE') {
          return true;
        }
      }

      return false;
    },
    isShowUnsubscribeSpace() {
      const authName = this.$store.getters['auth/getAuthName'];
      if (!this.isplayaimusicsong) {
        if (authName === 'UNSUBSCRIBED_WITH_SPACE') {
          return true;
        }
      }

      return false;
    },
    getSpaceCardInfo() {
      return this.$store.getters['player/getSpaceCardInfo'];
    },
    getAiMusicChannelName() {
      const { spaceNm } = this.getSpaceCardInfo;
      return `${spaceNm}의 로고송`;
    },
    getAiMusicMusicName() {
      return `${this.userName}님의 특별한 노래`;
    },
    userName() {
      return this.$store.getters['auth/getUserName'];
    }
  },
  watch: {
    isMute(val) {
      if (val) {
        this.setBackGround(this.$refs.volumeRange, 0);
      } else {
        this.$VideoPlayer.setVolume(this.$store.getters['player/getVolume']);
        this.$BrandPlayer.setBrandVideoVolume(this.$store.getters['player/getVolume']);
        this.setAiMusicVolume(this.$store.getters['player/getVolume']);
        this.setBackGround(this.$refs.volumeRange, this.$store.getters['player/getVolume']);
      }
    },
    async isplayaimusicsong(val) {
      await this.$nextTick();
      if (this.$refs.volumeRange) {
        this.setBackGround(
          this.$refs.volumeRange,
          this.$store.getters['player/getVolume'] ? this.$store.getters['player/getVolume'] : 1
        );
      }
    },
    getMyChannelType(val) {
      if (val) {
        if (this.$refs.volumeRange) {
          this.setBackGround(
            this.$refs.volumeRange,
            this.$store.getters['player/getVolume'] ? this.$store.getters['player/getVolume'] : 1
          );
        }
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/pagefooter/pagefooter.css"></style>
